import useOnMount from '@rio-cloud/rio-uikit/hooks/useOnMount';
import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import type { Location } from 'history';
import { FormattedMessage } from 'react-intl';
import { type NavigateFunction, useLocation, useNavigate } from 'react-router';
import { validate } from 'uuid';

import GeofenceCreationForm from './GeofenceForm';
import GeofenceSidebarFooter from './GeofenceSidebarFooter';

export type GeofenceCreationSidebarProps = {
    mode: 'CREATE' | 'UPDATE';
    autofillFromQueryString: (search: string) => void;
    onDelete: (geofenceId: string) => void;
    onClose: (navigate: NavigateFunction) => void;
    onSubmitForm: (navigate: NavigateFunction) => void;
    onClickSubmit: () => void;
    submitDisabled: boolean;
    validShape?: boolean;
};

const resolveGeofenceId = (location: Location): string | undefined => {
    const possibleGeofenceId = location.pathname.split('/').pop();
    if (possibleGeofenceId && validate(possibleGeofenceId)) {
        return possibleGeofenceId;
    }
    return undefined;
};

export const GeofenceSidebar = (props: GeofenceCreationSidebarProps) => {
    const location = useLocation();
    const navigate = useNavigate();
    const geofenceId = resolveGeofenceId(location);

    useOnMount(() => {
        props.autofillFromQueryString(location.search);
    }, []);

    const handleDelete = () => {
        if (geofenceId) {
            props.onDelete(geofenceId);
        }
    };

    const handleCLose = () => {
        props.onClose(navigate);
    };

    const handleOnSubmit = () => {
        props.onSubmitForm(navigate);
    };

    return (
        <Sidebar
            title={
                props.mode === 'CREATE' ? (
                    <FormattedMessage id='intl-msg:geofence.create.title' />
                ) : (
                    <FormattedMessage id='intl-msg:geofence.edit.title' />
                )
            }
            onClose={handleCLose}
            closed={false}
            titleClassName='text-size-large margin-left-10'
            footer={
                <GeofenceSidebarFooter
                    onDeleteHandler={handleDelete}
                    onAbortHandler={handleCLose}
                    onSubmitHandler={props.onClickSubmit}
                    submitDisabled={props.submitDisabled}
                    mode={props.mode}
                />
            }
        >
            <div className='padding-20 padding-top-0'>
                <GeofenceCreationForm validShape={props.validShape} geofenceId={geofenceId} onSubmit={handleOnSubmit} />
            </div>
        </Sidebar>
    );
};
